export const convertNanoToMilli = (nano) => Math.trunc(nano / 1000000);
